<template>
  <div class="language-selection " :style="`background-image: url(${$store.state.assetsPath}${$store.state.config.categorySelectionBackground});`">
    <div class="language-selection__categories">
      <div
        v-for="language in languages"
        class="language-selection__category touch"
        :class="language.code"
        :key="language.code"
        @click="setLanguage(language)"
      >
        <div class="language-selection__category-inner">
          {{ language.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  computed: {

    categories () {
      return this.$store.getters.navigation
    },

    languages () {
      return this.$store.getters.languages
    }
  },

  methods: {
    ...mapActions([
      'activateCategoryById'
    ]),

    setLanguage (language) {
      this.$store.commit('SET_LANGUAGE', language)
      this.$router.push('/select')
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
.language-selection  {
  align-items: center;
  background-size: cover;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  font-family: 'Nexa';

  &__categories {
    display: flex;
    flex-wrap: wrap;
    width: 50%;
  }

  &__category {
    height: 25rem;
    padding: 2rem;
    width: 50%;

    &.ar {
      font-family: 'GE Dinkum';
    }    
  }

  &__category-inner {
    align-items: center;
    background-color: rgba($black, 0.75);
    display: flex;
    font-size: 3rem;
    height: 100%;
    width: 100%;
    justify-content: center;
    
  }
}
</style>